import React, { createContext, useContext, useState, useMemo } from 'react';

const ProductContext = createContext();

export const useProductContext = () => {
  const context = useContext(ProductContext);
  if (!context) {
    return { selectedProduct: null, setSelectedProduct: () => {} };
  }
  return context;
};

export const ProductProvider = ({ children }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const value = useMemo(() => ({ selectedProduct, setSelectedProduct }), [selectedProduct]);

  return (
    <ProductContext.Provider value={value}>
      {children}
    </ProductContext.Provider>
  );
};

